/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';
import InputModal from 'app/components/InputModal/InputModal.jsx';
import Content from 'app/components/common/Content.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import * as _ from 'underscore';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import setInputDefaults from 'app/mixins/InputDefaultsModule.js';
import ChooseFeedType from 'app/components/CreateFeed/ChooseFeedType.jsx';
import CreateFeed from 'app/components/CreateFeed/CreateFeed.jsx';
import CreateSubtypePanel from 'app/components/EditorComponents/CreateSubtypePanel.jsx';
import CreateFeedConfigure from 'app/components/CreateFeed/CreateFeedConfigure.jsx';
import InstagramConfigPanel from 'app/components/EditorComponents/InstagramConfigPanel.jsx';
import CreateFeedSocial from 'app/components/CreateFeed/CreateFeedSocial.jsx';
import CreateFeedHeader from 'app/components/Headers/CreateFeedHeader.jsx';
import NewRouteProgress from 'app/components/CreateFeed/NewRouteProgress.jsx';
import FeedEditorTabs from 'app/components/EditorComponents/FeedEditorTabs.jsx';
import EditorButtons from 'app/components/EditorComponents/EditorButtons.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import InputFieldUpdateMixin from 'app/mixins/InputFieldUpdateMixin.js';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import Loading from 'app/components/common/Loading.jsx';
import { compose } from 'redux';
import FeedProvider from 'app/redux/Providers/FeedProvider.jsx';
import Utilities from 'app/utility/Utilities.js';
import UserMessages from 'app/modules/UserMessageModule.js';
import TwitterInputConfigPanel from 'app/components/EditorComponents/TwitterInputConfigPanel.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import AccessoryModal from 'app/components/PostingTool/AccessoryModal.jsx';
import PostingGroups from 'app/components/PostingTool/Accessories/PostingGroups.jsx';

class RouteNew extends React.Component {
	constructor(props) {
		super(props);

		let constants = props.app.config.constants;

		this.guidedInputs = [
			constants.INPUT_TYPE_TWITTER,
			constants.INPUT_SUBTYPE_EBAY,
			constants.INPUT_SUBTYPE_ETSY,
			constants.INPUT_SUBTYPE_VIMEO,
			constants.INPUT_SUBTYPE_SHOPIFY,
			constants.INPUT_SUBTYPE_SUBSTACK,
			constants.INPUT_SUBTYPE_PINTEREST,
			constants.INPUT_SUBTYPE_YOUTUBE
		];

		this.state = {
			route: {
				name: 'My New Route',
				type: props.app.config.constants.R_DEFAULT,
				activeFlag: true,
				inputs: [],
				socials: [],
				options: {
					filters: {},
					tracking: '',
					shortenerId: ''
				}
			},
			routeCreateError: null,
			validationErrors: null,
			validatingFeed: false,
			socialButtonActive: false,
			editedInput: null,
			authState: '',
			searchErrors: null,
			newPath: '',
			creatingSocial: false,
			newSocial: null,
			externalFeedUrl: '',
			baseUrl: '/share/automate/',
			mainTweeter: 0,
			inputType: 0,
			crossPostType: 0,
			subtypeConfigured: null,
			searchQuery: '',
			isDuplicateSocial: false,
			showPostGroupModal: false,
			incomingSocialsChecked: false,
			isFromWelcomePage: false,
			isFromAutomationsPage: false
		};

		this.transitionToFeedConfigure = this.transitionToFeedConfigure.bind(this);
		this.transitionToSocialSelection = this.transitionToSocialSelection.bind(this);
		this.validateInputConfiguration = this.validateInputConfiguration.bind(this);
		this.createInput = this.createInput.bind(this);
		this.feedRemoval = this.feedRemoval.bind(this);
		this.onSocialClick = this.onSocialClick.bind(this);
		this.onSubtypeClick = this.onSubtypeClick.bind(this);
		this.onConnectSocial = this.onConnectSocial.bind(this);
		this.onAdvancedFeedConfigure = this.onAdvancedFeedConfigure.bind(this);
		this.saveNewRoute = this.saveNewRoute.bind(this);
		this.filterSocialsByName = this.filterSocialsByName.bind(this);
		this.filterSocialsByType = this.filterSocialsByType.bind(this);
		this.updateRouteName = this.updateRouteName.bind(this);
		this.storeRouteState = this.storeRouteState.bind(this);
		this.removeInvalidFeeds = this.removeInvalidFeeds.bind(this);
		this.redirectOnInvalidState = this.redirectOnInvalidState.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
		this.setMainTweeter = this.setMainTweeter.bind(this);
		this.resetTwitters = this.resetTwitters.bind(this);
		this.modalSave = this.modalSave.bind(this);
		this.selectInputType = this.selectInputType.bind(this);
		this.returnToTiles = this.returnToTiles.bind(this);
		this.setSearchQuery = this.setSearchQuery.bind(this);
		this.showPostGroupModal = this.showPostGroupModal.bind(this);
		this.setNewSocial = this.setNewSocial.bind(this);

		// do initial load of routes and socials
		props.getRoutes();
		props.getSocials();
		props.getSocialTypes();

	}

	static getDerivedStateFromProps(props, state) {
		let nextState = {},
			i = 0,
			errors = [],
			constants = props.app.config.constants;

		errors = props.getApiErrors(['FEED_SEARCH']);
		if (errors.length) {
			nextState.searchErrors = errors[0];
		} else if (state.searchErrors !== null) {
			nextState.searchErrors = null;
		}

		return Object.keys(nextState).length ? nextState : null;

	}

	componentDidMount() {

		let socials = null,
			route = this.state.route,
			socialButtonActive = this.state.socialButtonActive,
			externalFeedUrl = '',
			constants = this.props.app.config.constants,
			mainTweeter = this.state.mainTweeter,
			onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

		this.props.restorePeristedData("newRouteState", (state) => {
			if (!this.props.router.location.pathname.match("new/outputs")) {
				state.subtypeConfigured = null;
				if (state.editedInput !== null && state.editedInput.inputValid !== undefined) {
					state.editedInput.inputValid = false;
				}
			}
			state.creatingSocial = false;
			this.setState(state, () => {
				this.redirectOnInvalidState();
				this.props.clearValidatedInputs();
				this.props.clearPersistedData('newRouteState');
			});
		}, this);


		if (this.props.router.query && this.props.router.query.url !== undefined) {
			externalFeedUrl = decodeURIComponent(this.props.router.query.url);
			this.setState({
				externalFeedUrl: externalFeedUrl
			});
		}

		if (this.props.router.query && this.props.router.query.welcome !== undefined) {
			this.setState({
				isFromWelcomePage: true
			});
		}

		if (this.props.router.query && this.props.router.query.automation !== undefined) {
			this.setState({
				isFromAutomationsPage: true
			});
		}

		if (this.props.router.location.pathname.match('content')) {
			this.setState({
				baseUrl: '/content/feed/'
			});
		}

		if (dataLayer && onboarding !== null) {
			if (onboarding.start === undefined) {
				dataLayer.push({
					'event': 'anchor-pageview',
					'virtualURL': '/vp/addFeed'
				},{
					'event': 'onboarding-start'
				});

				if (mixpanel !== undefined) {
					mixpanel.track("Onboarding - Start");
				}

				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Onboarding - Start',
					})
				}

				onboarding.start = true;
				window.localStorage.setItem('onboarding', JSON.stringify(onboarding));

			}
		}

		// clear out social filter on mount
		this.props.clearFilter('socials');

	}

	componentDidUpdate(prevProps, prevState) {
		let route = this.state.route,
			input = {},
			authState = this.state.authState,
			path = '',
			constants = this.props.app.config.constants,
			onboarding = null,
			checkState = this.checkState,
			socialButtonActive = this.state.socialButtonActive,
			errors = [],
			i = 0,
			validationErrors = this.state.validationErrors,
			validatingFeed = this.state.validatingFeed,
			searchErrors = this.state.searchErrors;

		this.redirectOnInvalidState();

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		// POST is there for the services that need it.
        // if not ignore it.
		if (this.props.app.configLoaded &&
			this.props.app.userLoaded &&
			this.props.app.userPermsLoaded &&
			this.props.app.firstLoad.SOCIAL_LIST) {
			if (this.props.authState.credID) {
				// reset authState in state now so other render ops
				// don't try to call again
				if (this.props.authState.credID.match(/^INPUT/) ||
					this.props.authState.credID.match(/^REAUTHINPUT/) ||
					this.props.authState.credID.match(/^REAUTHREUSE/)) {
					this.props.authReturnHandler.apply(this, [
						null,
						this.createInput]);
				} else if (this.props.authState.credID.match(/^POST/)) {
					this.props.authReturnHandler.apply(this, [{
						path: this.state.baseUrl + 'new/outputs'
					},
					(social) => {
						this.props.resetAuthState();
						this.setState({
							newSocial: social
						});
					}]);
					if (dataLayer && this.props.automatedRoutes.length === 0) {
						dataLayer.push({
							'event': 'anchor-pageview',
							'virtualURL': '/vp/addSocial'
						});
					}
					if (mixpanel !== undefined && onboarding !== null) {
						mixpanel.track("Social Auth Return", {
							socialAuthorized: ConstantMixin.getPostServiceNameByCode(authState.split("_")[1])
						});
						mixpanel.time_event("Social Created on dlvr.it");
					}
					if (this.props.recordEvent && onboarding !== null) {
						this.props.recordEvent({
							pub_id: this.props.user.detail.id,
							event_name: 'Social Auth Return',
							event_data: {
								social: ConstantMixin.getPostServiceNameByCode(authState.split("_")[1])
							}
						})
					}
					this.setState({
						creatingSocial: true
					});
				}
			}
		}

		if (prevProps.app.loading.FEED_SEARCH === true && this.props.app.loading.FEED_SEARCH === false) {
			// the tile page passes the users search query to the CreateFeed component through RouteNew
			// in the searchQuery state var. When a feed search completes, it's safe to clear it.
			if (this.state.searchQuery !== '') {
				this.setState({
					searchQuery: ''
				});
			}
			if (this.props.feeds.searchResults.feeds.length && this.state.searchErrors !== null) {
				this.setState({
					searchErrors: null
				});
			}
		}

		if (prevProps.app.loading.FEED_VALIDATE === true && this.props.app.loading.FEED_VALIDATE === false) {
			errors = this.props.getApiErrors(['FEED_VALIDATE']);

			if (validatingFeed) {
				validatingFeed = false;
			}

			if (errors.length) {
				validationErrors = errors[0];
			} else {
				for (i = 0; i < route.inputs.length; ++i) {
					if (this.props.feeds.validated.length) {
						if (this.props.feeds.validated.indexOf(route.inputs[i].url) !== -1) {
							route.inputs[i].feedValid = true;
							// set the input valid flag true here for advanced
							// flag is set to false when opening the edit modal and updated on save for edits
							// but if no edits... flag needs to be set for user to finish creating route
							if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
								route.inputs[i].inputValid = true;
							}
							validationErrors = null;
						}
					}
				}
			}
			this.setState({
				route,
				validatingFeed,
				validationErrors,
				searchErrors
			});
		}

		if (prevProps.app.loading.INPUT_VALIDATE === true && this.props.app.loading.INPUT_VALIDATE === false) {
			let editedInput = this.state.editedInput,
				subtypeConfigured = this.state.subtypeConfigured;

			errors = this.props.getApiErrors(['INPUT_VALIDATE']);
			if (errors.length) {
				validationErrors = errors[0];
				//using this variade as a 3 state
				// null == go to configure page
				// false == on configure page safe to advance to social
				subtypeConfigured = (!subtypeConfigured) ? null : false;
			} else {
				if (this.props.automatedRoutes.validInputs.length && !_.isEmpty(editedInput)) {
					for (i = 0; i < this.props.automatedRoutes.validInputs.length; ++i) {
						if (this.props.automatedRoutes.validInputs[i].id == editedInput.id) {
							editedInput = _.clone(this.props.automatedRoutes.validInputs[i]);
							// clear validatedInputs so the twice-validated inputs can work
							this.props.clearValidatedInputs();
							if (editedInput.inputValid !== undefined && editedInput.inputValid === false) {
								editedInput.inputValid = true;
							}
							validationErrors = null;
						}
					}
					for (i = 0; i < route.inputs.length; ++i) {
						if (route.inputs[i].id == editedInput.id) {
							route.inputs[i] = editedInput;
						}
					}
				}
			}

			this.setState({
				route,
				editedInput,
				validationErrors,
				subtypeConfigured
			});

			if (validationErrors === null) {
				if (subtypeConfigured === false) {
					this.transitionToFeedConfigure();
				} else {
					if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
						if (this.state.editedInput.type == constants.INPUT_TYPE_TWITTER) {
							this.transitionToSocialSelection();
						} else {
							this.props.router.navigate(`${this.state.baseUrl}new/inputs`);
						}
					} else {
						this.transitionToSocialSelection();
					}
				}
			}
		}

		// we just created a new route -- redirect
		if (prevProps.app.loading.ROUTE_CREATE === true && this.props.app.loading.ROUTE_CREATE === false) {
			let routeCreateErrors = this.props.getApiErrors(['ROUTE_CREATE']),
				createError = 'There was a problem creating your route',
				nextRoute = Utilities.deepClone(this.state.route);
			
			// roll up the window to show the error
			window.scrollTo(0, 0);

			if (routeCreateErrors.length) {
				let routeCreateError = routeCreateErrors[0].errors;

				if (routeCreateError.socials !== undefined) {
					let keys = Object.keys(routeCreateError.socials),
						errorId = keys[0];

					if (errorId) {
						let social = this.props.socials.list.find(({id}) => { return errorId == id; });
						if (social) {
							nextRoute.socials.splice(nextRoute.socials.indexOf(social.id), 1);
							if (nextRoute.socials.length) {
								socialButtonActive = true;
							}
							createError = (
								<span>
									<strong>Warning!</strong> You nearly created an endless posting loop.<br/>
									<strong>{social.name}</strong> is no longer selected as an output.
								</span>
							);
						}
					}
				} 

				this.setState({
					route: nextRoute,
					routeCreateError: createError,
					socialButtonActive
				});
				this.props.deleteApiError(['ROUTE_CREATE']);
				
			} else {
				// new routes are pushed onto the end of automatedRoutes.list
				let newRoute = this.props.automatedRoutes.list[this.props.automatedRoutes.list.length - 1];
				this.props.addMessage(UserMessages.generateMessage(UserMessages.route.created, 'ROUTE_CREATE'));
				if (dataLayer) {
					dataLayer.push({
						'event': 'anchor-pageview',
						'virtualURL': '/vp/routeCreated'
					},
					{
						'event': 'onboarding-route-created'
					});
				}
				if (mixpanel !== undefined && onboarding !== null) {
					mixpanel.track('Onboarding - Complete');
				} else if (mixpanel !== undefined && onboarding === null) {
					mixpanel.track('Route Created');
				}
				if (dataLayer && onboarding !== null) {
					dataLayer.push({
						event: 'first_post',
						method: 'feed'
					});
				}

				if (this.props.recordEvent && onboarding !== null) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Onboarding - Complete',
						event_data: {
							'method': 'Route Created'
						}
					});
				} else if (this.props.recordEvent && onboarding === null) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Route Created'
					});
				}

				// fetch the social input creds in case we have fresh ones
				this.props.getSocialInputCreds();

				if (onboarding !== null) {
					window.localStorage.removeItem('onboarding');
				}
				// reset social filter here
				this.props.clearFilter('socials');
				if (newRoute !== undefined && newRoute !== null && newRoute.id) {
					this.props.router.navigate('/share/automate/detail/' + newRoute.id);
				}
			}
		}

		if (prevProps.app.loading.SOCIAL_CREATE === true && this.props.app.loading.SOCIAL_CREATE === false) {
			let newSocial = _.difference(_.pluck(this.props.socials.list, 'id'), _.pluck(prevProps.socials.list, 'id'));
			// only push the social into the new route if we can tell what the new one is
			// Charles added an existing social through the new and well, the code can't tell what's new
			// so do the rest of the work
			if (newSocial && newSocial.length) {
				// only push the social onto the list if it's not tiktok
				//let social = this.props.socials.list.find(({id}) =>  { return newSocial[0] === id; });
				//if ([constants.POST_SVC_TIKTOK, constants.POST_SVC_YOUTUBE].indexOf(social.psID) === -1) {
					route.socials.push(newSocial[0]);
				//}
			}
			this.props.closeAllModals();
			this.props.getUserPerms();
			socialButtonActive = true;
			this.setState({
				route,
				socialButtonActive,
				creatingSocial: false
			});
		}


		if (prevProps.app.loading.SOCIAL_UPDATE === true && this.props.app.loading.SOCIAL_UPDATE === false) {
			this.props.getUserPerms();
		}

		// trying to catch onboarding and select all socials
		if (this.props.socials.list.length <= 2 && this.props.socials.list.length > 0 && route.socials.length === 0 && !this.state.incomingSocialsChecked) {
			let twitterCount = 0;
			for (i = 0; i < this.props.socials.list.length; ++i) {
				if (this.props.socials.list[i].psID == constants.POST_SVC_TWITTER) {
					++twitterCount;
				}
			}
			if (twitterCount <= 1) {
				this.props.socials.list.map((social) => {
					if (social && social.id !== undefined) {
						//if ([constants.POST_SVC_TIKTOK, constants.POST_SVC_YOUTUBE].indexOf(social.psID) === -1) {
							route.socials.push(social.id);
						//}
					}
				});
				socialButtonActive = true;
				this.setState({
					route,
					socialButtonActive,
					incomingSocialsChecked: true
				});
			}
		}

		if ((prevProps.socials.list.length < this.props.socials.list.length) && prevProps.app.loading.SOCIAL_LIST === false && this.props.app.loading.SOCIAL_LIST === false) {
			this.setState({
				creatingSocial: false
			});
		}

		errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
		if (errors.length) {
			if (this.props.isDuplicateSocial() && this.state.isDuplicateSocial === false) {
				this.setState({
					isDuplicateSocial: true
				}, () => {
					let social = Utilities.deepClone(this.state.newSocial);

					this.props.showDuplicateSocialModal(social, {
						confirm: () => {
							this.props.closeAllModals();
							this.setState({
								newSocial: null,
								isDuplicateSocial: false
							});
						},
						cancel: () => {
							this.props.closeAllModals();
							this.setState({
								creatingSocial: false,
								newSocial: null,
								isDuplicateSocial: false
							});
						}
					});
				});
			} else if (this.props.isBlacklisted() && this.state.isDuplicateSocial === false) {
				this.props.showBlacklistModal({
					confirm: () => {
						this.setState({
							creatingSocial: false,
							newSocial: null,
							isDuplicateSocial: false
						});
						this.props.deleteApiError(['SOCIAL_CREATE']);
						this.props.closeAllModals();
					}
				});

				this.setState({
					isDuplicateSocial: true
				});
			}
		}

		// reset state on free-form navigation
		if ((prevProps.router.location.pathname.match("new/configure") && this.props.router.location.pathname.match("new/inputs")) ||
			(prevProps.router.location.pathname.match("new/outputs") && this.props.router.location.pathname.match("new/configure")) ||
			(prevProps.router.location.pathname.match("new/outputs") && this.props.router.location.pathname.match("new/inputs"))) {
			let editedInput = this.state.editedInput,
				subtypeConfigured = this.state.subtypeConfigured;
			if (this.state.subtypeConfigured !== null) {
				if (this.props.router.location.pathname.match("new/configure")) {
					subtypeConfigured = false;
				} else {
					subtypeConfigured = null;
				}
				editedInput.inputValid = false;
				this.props.clearValidatedInputs();
				this.setState({
					editedInput,
					subtypeConfigured,
				});
			}
			// reset the routeCreateError and selected socials on navigation
			let nextRoute = Utilities.deepClone(this.state.route);
			nextRoute.socials = [];
			this.setState({
				routeCreateError: null,
				route: nextRoute
			});
		}

	}

	componentWillUnmount() {

		this.props.clearFilter('socials');

		this.props.resetAuthState();

	}

	redirectOnInvalidState() {

		let currentPath = this.props.router.location.pathname;

		// Be sure they haven't reached configure or outputs with no inputs
		if (currentPath.match("new/configure") && this.state.route.inputs.length === 0 ||
			currentPath.match("new/outputs") && this.state.route.inputs.length === 0) {
			this.props.router.navigate(this.state.baseUrl + 'new/inputs');
		}

	}

	transitionToFeedConfigure(e) {
		let onboarding = null;

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		if (e) {
			e.preventDefault();
		}

		if (dataLayer && onboarding !== null) {
			dataLayer.push({
				'event': 'anchor-pageview',
				'virtualURL': '/vp/configureFeed'
			},{
				'event': 'onboarding-configure'
			});
		}
		if (onboarding !== null) {
			if (onboarding.configureFeed === undefined) {
				if (mixpanel !== undefined) {
					mixpanel.track("Onboarding - Configure feed");
				}
				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Onboarding - Configure feed'
					});
				}
				onboarding.configureFeed = true;
				window.localStorage.setItem('onboarding', JSON.stringify(onboarding));
			}
		}

		this.props.router.navigate(this.state.baseUrl + 'new/configure');

	}

	transitionToSocialSelection(e) {
		let onboarding = null;

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		if (e) {
			e.preventDefault();
		}

		if (dataLayer && onboarding !== null) {
			dataLayer.push({
				'event': 'anchor-pageview',
				'virtualURL': '/vp/addSocial'
			},
			{
				'event': 'onboarding-start-social'
			});
		}
		if (onboarding !== null) {
			if (onboarding.startSocial === undefined) {
				if (mixpanel !== undefined) {
					mixpanel.track("Onboarding - Start Add Social");
				}
				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Onboarding - Connect Social'
					});
				}
				onboarding.startSocial = true;
				window.localStorage.setItem('onboarding', JSON.stringify(onboarding));
			}
		}

		this.props.router.navigate(this.state.baseUrl + 'new/outputs');

	}

	modalSave(input) {
		input.inputValid = false;

		this.setState({
			editedInput: input
		}, () => {
			this.props.validateInput(this.state.editedInput);
		});
	}

	validateInputConfiguration(e) {
		let onboarding = null,
			editedInput = this.state.editedInput;

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		this.props.deleteApiError(['INPUT_VALIDATE']);

		editedInput.inputValid = false;
		this.props.clearValidatedInputs();

		this.setState({
			editedInput
		});

		if (this.guidedInputs.indexOf(this.state.editedInput.type) !== -1 || this.guidedInputs.indexOf(this.state.editedInput.subtype) !== -1) {
			// we have a subtype or a type that gets the same flow
			let serviceName = ConstantMixin.getInputServiceByCode(this.state.inputType);

			if (this.state.subtypeConfigured === null) {
				this.setState({
					subtypeConfigured: false
				}, () => {
					if (dataLayer) {
						dataLayer.push({
							'event': 'setting-feed-url',
							'service': serviceName,
							'onboarding': (onboarding !== null) ? true : false
						});
					}
					if (mixpanel) {
						mixpanel.track("Setting Feed URL", {
							onboarding: (onboarding !== null) ? true : false,
							type: serviceName
						});
					}
					if (this.props.recordEvent) {
						this.props.recordEvent({
							pub_id: this.props.user.detail.id,
							event_name: 'Setting Feed URL',
							event_data: {
								onboarding: (onboarding !== null) ? true : false,
								type: serviceName
							}
						})
					}
					this.props.validateInput(this.state.editedInput);
				});
			} else if (this.state.subtypeConfigured === false) {
				this.setState({
					subtypeConfigured: true,
				}, () => {
					if (dataLayer) {
						dataLayer.push({
							'event': 'set-feed-url',
							'service': serviceName,
							'onboarding': (onboarding !== null) ? true : false
						});
					}
					if (mixpanel) {
						mixpanel.track("Set Feed URL", {
							onboarding: (onboarding !== null) ? true : false,
							type: serviceName
						});
					}
					if (this.props.recordEvent) {
						this.props.recordEvent({
							pub_id: this.props.user.detail.id,
							event_name: 'Set Feed URL',
							event_data: {
								onboarding: (onboarding !== null) ? true : false,
								type: serviceName
							}
						})
					}
					this.props.validateInput(this.state.editedInput);
				});
			}
		} else {
			this.props.validateInput(this.state.editedInput);
		}

	}

	createInput(input) {
		let route = this.state.route,
			constants = this.props.app.config.constants,
			validatingFeed = this.state.validatingFeed,
			authState = this.state.authState,
			inputType = this.state.inputType,
			path = '',
			advancedDestination = this.state.baseUrl + 'new/configure/input/setup',
			simpleDestination = this.state.baseUrl + 'new/configure',
			searchErrors = this.state.searchErrors;

		setInputDefaults.apply(this, [input, input.type, this.props.user.perms, constants.R_DEFAULT]);

		if (input.type == constants.INPUT_TYPE_FEED && input.subtype === undefined) {
			this.props.feedValidate(input.url);
			validatingFeed = true;
			simpleDestination = advancedDestination = this.state.baseUrl + 'new/inputs';
			this.props.deleteApiError(['FEED_SEARCH']);
			searchErrors = null;
		} else if (input.subtype == constants.INPUT_SUBTYPE_PINTEREST) {
			// no op --- for now
		} else if (input.type == constants.INPUT_TYPE_INSTAGRAM || input.type == constants.INPUT_TYPE_INSTAGRAM_BUSINESS) {
			if (input.scID) {
				let creds = null;
				if (this.props.automatedRoutes.socialInputCreds[input.type] !== undefined) {
					creds = this.props.automatedRoutes.socialInputCreds[input.type].find((cred) => { return cred.scID === input.scID; });
					if (creds) {
						input.name = creds.scName;
					}
				}
			} else {
            	input.name = input.username;
			}
        } else if (input.type == constants.INPUT_TYPE_TWITTER) {
            input.attrs.user_name = "@" + input.username;
            input.name = "@" + input.username + " Timeline";
			inputType = constants.INPUT_TYPE_TWITTER;
		} else if (input.type == constants.INPUT_TYPE_FACEBOOK_PAGE) {
			if (input.scID) {
				let creds = null;
				if (this.props.automatedRoutes.socialInputCreds[input.type] !== undefined) {
					creds = this.props.automatedRoutes.socialInputCreds[input.type].find((cred) => { return cred.scID === input.scID; });
					if (creds) {
						input.name = creds.scName + " Posts";
					}
				}
			} else {
				input.name = input.username + " Posts";
			}
			inputType = constants.INPUT_TYPE_FACEBOOK_PAGE;
		}

		route.inputs.push(input);

		this.setState({
			route: route,
			editedInput: input,
			validatingFeed,
			inputType,
			searchErrors
		}, () => {
			if (this.props.app.flags.routeViewType == constants.ROUTE_VIEW_ADVANCED) {
				path = advancedDestination;
			} else {
				path = simpleDestination;
			}

			// just change path if advanced
			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
				this.props.router.navigate(path);
			} else if (this.guidedInputs.indexOf(input.type) !== -1) {
				this.props.router.navigate('/share/automate/new/inputs');
			} else if (this.guidedInputs.indexOf(input.type) === -1 && this.guidedInputs.indexOf(input.subtype) === -1) {
				this.props.router.navigate(path);
			}
		});

		// clean up the Auth State before doing any kind of transition (if applicable)
		this.props.resetAuthState();

	}

	feedRemoval(feedId, removeInvalid) {
		let updatedRoute = this.state.route,
			updatedInputs = [],
			i = 0;

		for (i = 0; i < updatedRoute.inputs.length; ++i) {
			if (feedId) {
				if (updatedRoute.inputs[i].id != feedId) {
					updatedInputs.push(updatedRoute.inputs[i]);
				}
			} else if (removeInvalid) {
				if (updatedRoute.inputs[i].valid) {
					updatedInputs.push(updatedRoute.inputs[i]);
				}
			}
		}

		updatedRoute.inputs = updatedInputs;

		//RouteStore.clearErrors('validate', 'input');

		this.setState({
			route: updatedRoute,
			validationErrors: null
		});
	}

	onSocialClick(event, id) {
		let state = this.state,
			socialId = 0,
			socialIndex = 0,
			onboarding = null,
			constants = this.props.app.config.constants,
			test = null,
			twitterCount = 0;

		if (event) {
			socialId = parseInt(event.currentTarget.dataset.id, 10);
		} else if (id) {
			socialId = id;
		}

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		if (state.route.socials.find((id) => { return id === socialId; }) === undefined) {
			let social = _.find(this.props.socials.list, function(social) {
				return socialId == social.id;
			});
			if (social && social.psID == constants.POST_SVC_TWITTER) {
				if (state.mainTweeter == 0) {
					state.mainTweeter = socialId;
				}
				for (let key in state.route.socials) {
					test = _.find(this.props.socials.list, function(social) {
						return state.route.socials[key] == social.id;
					});
					if (test !== undefined) {
						if (test.psID == constants.POST_SVC_TWITTER) {
							++twitterCount;
						}
					}
				}
				if ((twitterCount + 1) > constants.MAX_TWITTER_OUTPUTS) {
					this.props.addMessage(UserMessages.generateFlashMessage("You've selected the maximum number of retweet accounts", "RETWEET_WARNING"));
					return;
				}
			}

			if (socialId) {
				state.route.socials.push(parseInt(socialId, 10));
				if (mixpanel !== undefined && onboarding !== null) {
					mixpanel.track("Onboarding - Social Selected");
				}
				if (this.props.recordEvent) {
					this.props.recordEvent({
						pub_id: this.props.user.detail.id,
						event_name: 'Onboarding - Social Selected'
					});
				}
			}
		} else {
			// if the event isn't passed in, this call is coming
			// from the posting groups modal, don't unselect any
			// previously selected socials
			if (event) {
				if (state.mainTweeter == socialId) {
					state.mainTweeter = 0;
				}
				state.route.socials = _.without(state.route.socials, socialId);
			}
		}

		if (state.route.socials.length >= 1) {
			state.socialButtonActive = true;
		} else {
			state.socialButtonActive = false;
		}

		this.setState(state);
	}

	onSubtypeClick(e, subtype) {
		let constants = this.props.app.config.constants,
			onboarding = null,
			serviceName = ConstantMixin.getInputServiceByCode(subtype);

		if (e) {
			e.preventDefault();
		}

		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		if (dataLayer && onboarding !== null) {
			dataLayer.push({
				'event': 'onboarding-create-subtype',
				'service': serviceName
			});
		}
		if (mixpanel !== undefined && onboarding !== null) {
			if (onboarding.createSubtype === undefined) {
				onboarding.createSubtype = true;
				mixpanel.track("Onboarding - Create " + serviceName + " Feed");
				window.localStorage.setItem('onboarding', JSON.stringify(onboarding));
			}
		}

		if (this.props.recordEvent && onboarding !== null) {
			this.props.recordEvent({
				pub_id: this.props.user.detail.id,
				event_name: "Onboarding - Add Feed Subtype",
				event_data: {
					service: serviceName
				}
			})
		}

		this.createInput({
			type: constants.INPUT_TYPE_FEED,
			subtype
		});

	}

	onConnectSocial(event) {

		let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

		let modal = (
			<SocialModal
				{...this.props}
				activeRoute={this.state.route}
				context="list"
				router={this.props.router}
				recordPath={this.props.recordPath}
				onboarding={onboarding}
				setNewSocial={this.setNewSocial}
				selectedSocials={this.state.route.socials}
				clearFilterOnClose={true}
				updateSelectedSocials={(updates) => {
					let nextRoute = Utilities.deepClone(this.state.route),
						nextSocials = [...nextRoute.socials];

					if (_.isArray(updates.add)) {
						updates.add.map((id) => {
							if (nextSocials.indexOf(id) === -1) {
								nextSocials.push(id);
							}
						});
					}
					if (_.isArray(updates.remove)) {
						updates.remove.map((id) => {
							if (nextSocials.indexOf(id) !== -1) {
								nextSocials.splice(nextSocials.indexOf(id), 1);
							}
						})
					}

					nextRoute.socials = nextSocials;

					this.setState({
						route: nextRoute
					});

				}} />
		);

		if (dataLayer && onboarding !== null) {
			dataLayer.push({
				'event': 'onboarding-start-social'
			});
		}
		if (mixpanel !== undefined && onboarding !== null) {
			mixpanel.track("Onboarding - Social Modal Opened");
			mixpanel.time_event("Social Auth Return");
		}

		this.props.persistData("newRouteState", this.state);

		this.props.addModal(modal);

	}

	onAdvancedFeedConfigure(e) {

		let input = {},
			i = 0,
			id = e.currentTarget.dataset.feedid,
			modal = null;

		for (i = 0; i < this.state.route.inputs.length; ++i) {
			if (this.state.route.inputs[i].id == id) {
				input = this.state.route.inputs[i];
				input.inputValid = false;
				break;
			}
		}

		this.setState({
			editedInput: input
		}, () => {
			this.props.router.navigate(this.state.baseUrl + 'new/configure/input');
		});

		this.props.clearValidatedInputs();

	}

	onModalClose(input) {
		let route = this.state.route,
			newInputs = [],
			i = 0;

		for (i = 0; i < route.inputs.length; ++i) {
			if ((_.isEqual(route.inputs[i], input) && route.inputs[i].valid === true) ||
			 	!_.isEqual(route.inputs[i], input)) {
				newInputs.push(route.inputs[i]);
			}
		}

		route.inputs = newInputs;

		this.setState({
			route: route
		});
		this.props.closeAllModals();
		this.props.router.navigate(this.state.baseUrl + 'new/inputs');

	}

	saveNewRoute() {
		let route = Utilities.deepClone(this.state.route),
			verifiedInputs = [],
			constants = this.props.app.config.constants;

		// for simple routes set the route name to the name of the input feed
		if (this.props.app.flags.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
			if (route.inputs && route.inputs[0] !== undefined) {
				route.name = route.inputs[0].name;
			}
		}

		if (this.state.mainTweeter) {
			let twitterCount = 0;
			for (let i = 0; i < route.socials.length; ++i) {
				let social = _.find(this.props.socials.list, function(social) {
						return route.socials[i] == social.id;
					}.bind(this));
				if (social) {
					if (social.psID == constants.POST_SVC_TWITTER) {
						++twitterCount;
					}
				}
			}
			if (twitterCount > 1) {
				route.tweeter = this.state.mainTweeter;
			}
		}

		// double check there aren't any invalid feeds
		for (let i = 0; i < route.inputs.length; ++i) {
			if (route.inputs[i].inputValid === true) {
				verifiedInputs.push(route.inputs[i]);
			}
		}

		// double check just to be safe
		if (!verifiedInputs.length) {
			// TODO: throw an error
			return;
		}

		route.inputs = verifiedInputs;

		this.setState({
			socialButtonActive: false,
			routeCreateError: null
		});

		this.props.createRoute(route);

		this.props.clearPersistedData('newRouteState');

	}

	filterSocialsByName(e, search) {
		this.props.filterStore('socials', ['name'], search);
	}

	filterSocialsByType(e, key) {
		let exact = false;
		if (key !== '') {
			exact = true;
		}
		this.props.filterStore('socials', ['psID'], key, exact);
	}

	updateRouteName(event) {
		let updatedRoute = this.state.route;

		updatedRoute.name = event.currentTarget.value;
		this.setState({
			route: updatedRoute
		});
	}

	storeRouteState(service) {
		let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

		if (service) {
			let serviceName = ConstantMixin.getInputServiceByCode(service);
			if (dataLayer && onboarding !== null) {
				dataLayer.push({
					'event': 'onboarding-connect-social-feed',
				});
			}
			if (mixpanel !== undefined && onboarding !== null) {
				mixpanel.track("Onboarding - Connect Social Feed", {
					type: serviceName
				});
			}

			if (this.props.recordEvent && onboarding !== null) {
				this.props.recordEvent({
					pub_id: this.props.user.detail.id,
					event_name: "Onboarding - Add Social Feed",
					event_data: {
						social: serviceName
					}
				})
			}
		}
		this.props.persistData("newRouteState", this.state);
	}

	removeInvalidFeeds() {

		this.feedRemoval(0, true);

	}

	setMainTweeter(id) {
		let socials = this.state.route.socials,
			route = this.state.route;

		if (id !== undefined) {
			id = parseInt(id, 10);
			if (socials.indexOf(id) === -1) {
				socials.push(id);
				route.socials = socials;
			}
			this.setState({
				route: route,
				mainTweeter: id
			});
		}

	}

	resetTwitters() {

		let confirm = function() {
				let constants = this.props.app.config.constants,
					route = this.state.route,
					socials = this.state.route.socials,
					newSocials = [],
					socialButtonActive = this.state.socialButtonActive;

				for (let i = 0; i < socials.length; ++i) {
					let social = _.find(this.props.socials.list, function(social){
						return social.id == socials[i];
					}.bind(this));
					if (social && social.psID !== constants.POST_SVC_TWITTER) {
						newSocials.push(socials[i]);
					}
				}
				route.socials = newSocials;

				if (newSocials.length === 0) {
					socialButtonActive = false;
				}

				this.props.closeAllModals();

				this.setState({
					route: route,
					mainTweeter: 0,
					currentModal: null,
					socialButtonActive: socialButtonActive
				});

			}.bind(this),
			cancel = function() {
				this.props.closeAllModals(null);
			}.bind(this),
			modal = (
				<ConfirmModal
					cancelAction={cancel}
					confirmAction={confirm}
					modalCopy={"Deselecting your main Twitter will remove all retweeters too. Click on the main account in the tray to change it instead."}/>
			);

		this.props.addModal(modal);

	}

	selectInputType(type, subtype, crossPostType) {
		let constants = this.props.app.config.constants,
			inputType = 0,
			route = this.state.route,
			editedInput = this.state.editedInput;

		// oauth types start oauthing from tile click
		// except for instagram where there's a second selection screen
		if (type === 'wordpress' || type === 'instagram_chooser' ||
			type === 'feed_search_tile' || type === 'website_tile' || type === 'cross_post') {
			inputType = type;
		} else {
			inputType = (parseInt(subtype, 10)) ? parseInt(subtype, 10) : parseInt(type, 10);
		}

		// reset the route inputs if a user clicks on a tile to maintain
		// one input at a time for simple
		route.inputs = [];

		if (inputType === constants.INPUT_TYPE_FEED ||
				inputType === constants.INPUT_TYPE_TWITTER ||
				inputType === constants.INPUT_TYPE_INSTAGRAM ||
				inputType === 'wordpress' ||
				inputType === 'instagram_chooser' ||
				inputType === 'cross_post' ||
				inputType === 'website_tile' ||
				inputType === 'feed_search_tile') {
			editedInput = {};
			this.props.resetFeedValidation();
		}

		this.setState({
			editedInput,
			inputType,
			crossPostType,
			route
		}, () => {
			// call subtype click *after* setting state so createInput is called in the
			// right order and doesn't clobber editedInput
			if (subtype) {
				this.onSubtypeClick(null, subtype);
			}
		});

	}

	returnToTiles(e) {

		if (e) {
			e.preventDefault();
		}

		if (this.state.isFromWelcomePage) {
			this.props.router.navigate("/welcome");
		} else if (this.state.isFromAutomationsPage) {
			this.props.router.navigate("/share/automations");
		} else {
			this.setState({
				inputType: 0,
				crossPostType: 0
			});
		}



	}

	setSearchQuery(value) {
		this.setState({
			searchQuery: value
		});
	}

	showPostGroupModal() {
		this.setState({
			showPostGroupModal: (this.state.showPostGroupModal) ? false : true
		});
	}

	setNewSocial(newSocial) {

		this.setState({
			newSocial
		});

	}

	render() {
		let Header = null,
			RouteName = null,
			MainContent = null,
			HeaderTabs = null,
			ConfigPanel = null,
			EditorButton = null,
			modal = null,
			canAddFeeds = true,
			tabClass = "",
			feedLink = "",
			errorNotice = null,
			searchErrors = null,
			constants = this.props.app.config.constants,
			currentPath = this.props.router.location.pathname,
			action = null,
			nextButtonLabel = "Continue",
			showOrientation = false,
			nextSectionLabel = '',
			feedType = null,
			topEditorButton = '',
			onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
			storeState = false,
			twitterInput = false,
			inputCount = 0,
			progressBlock = null;

		if (this.props.app.configLoaded === false || this.props.app.loading.USER_FETCH) {
			return null;
		}

		// Be a user hasn't reached configure or outputs with no inputs
		if ((currentPath.match("new/configure") && this.state.route.inputs.length === 0) ||
			(currentPath.match("new/outputs") && this.state.route.inputs.length === 0)) {
			return null;
		}

		if (this.props.app.loading.SOCIAL_LIST) {
			return (
				<Loading/>
			);
		}

		if (this.state.validatingFeed) {
			nextButtonLabel = (
				<div>
					<i className="fa fa-spinner fa-pulse"></i> Working
				</div>
			);
		}

		if (this.props.automatedRoutes.list.length === 0) {
			showOrientation = true;
		}

		if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
			RouteName = <input type="text" className="dlvr-form text-input short" defaultValue={this.state.route.name} onChange={this.updateRouteName}/>;
			Header = <CreateFeedHeader section="Your Routes" sectionLink="/share/automate" sectionParams={{}} action={RouteName}/>
		} else {
			Header = <CreateFeedHeader section="Your Feeds" sectionLink="/share/automate" sectionParams={{}} action="New Feed"/>
			if (this.state.route.inputs.length === 1) {
				canAddFeeds = false;
			}
		}

		if (onboarding !== null) {
			Header = null;
		}

		if (this.state.route.inputs.length >= 1) {
			inputCount = this.state.route.inputs.length;
			for (let i = 0; i < this.state.route.inputs.length; ++i) {
				if (this.state.route.inputs[i].type == constants.INPUT_TYPE_TWITTER) {
					twitterInput = true;
					break;
				}
			}
		}

		if (currentPath.match("new/inputs") ||
			(currentPath.match('new/configure') && this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) ||
			(currentPath.match(/content$/) || currentPath.match(/content\/feed$/))) {

			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
				action = this.transitionToSocialSelection;
				nextButtonLabel = (
					<span>Select outputs <i className="icon ion-ios-arrow-right"></i></span>
				);
				nextSectionLabel = '';

				let inputValidated = false;
				if (this.state.route.inputs.length) {
					inputValidated = true;
					for (let i = 0; i < this.state.route.inputs.length; ++i) {
						if (!this.state.route.inputs[i].inputValid) {
							inputValidated = false;
							break;
						}
					}
				}

				EditorButton =  (
					<EditorButtons
						{...this.props}
						showCancel={false}
						saveActive={inputValidated}
						saveLabel={nextButtonLabel}
						stepLabel={nextSectionLabel}
						saveAction={action} />
				);

			} else {
				action = this.transitionToFeedConfigure;
				nextButtonLabel = (
					<span>Post Settings <i className="icon ion-ios-arrow-right"></i></span>
				);
				nextSectionLabel = '';

				let feedsValidated = false;
				if (this.state.route.inputs.length) {
					feedsValidated = true;
					for (let i = 0; i < this.state.route.inputs.length; ++i) {
						// only feed types need to check for validation
						let noValidationTypes = [
							constants.INPUT_TYPE_TWITTER,
							constants.INPUT_TYPE_FACEBOOK_PAGE,
							constants.INPUT_TYPE_INSTAGRAM,
							constants.INPUT_TYPE_INSTAGRAM_BUSINESS
						];
						if (noValidationTypes.indexOf(parseInt(this.state.route.inputs[i].type, 10)) === -1) {
							if (this.state.route.inputs[i].feedValid === undefined ||
								!this.state.route.inputs[i].feedValid) {
								feedsValidated = false;
								break;
							}
						}
					}
				}

				EditorButton = (
					<EditorButtons
						{...this.props}
						showCancel={false}
						saveActive={feedsValidated}
						saveLabel={nextButtonLabel}
						stepLabel={nextSectionLabel}
						returnToTiles={this.returnToTiles}
						saveAction={action} />
				);
			}

			if (this.state !== null) {
				searchErrors = this.state.searchErrors;
			}

			if (this.state.validationErrors !== null) {
				searchErrors = this.state.validationErrors;
				errorNotice = (
					<div className="detail-status error">
						{"We can't get the feed you wanted. Check the errors for details."}
					</div>
				);
			}

			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE && (this.state.inputType === 0 || this.state.inputType === 'instagram_chooser' || this.state.inputType === 'cross_post')) {
				MainContent = (
					<div>
						<NewRouteProgress
							{...this.props}
							inputType={this.state.inputType}
							currentSection={1}
							goToStep={this.goToStep}
							newRoute={this.state.route} />
						<ChooseFeedType
							{...this.props}
							inputType={this.state.inputType}
							crossPostType={this.state.crossPostType}
							inputSelectCallback={this.selectInputType}
							returnToTiles={this.returnToTiles}
							setSearchQuery={this.setSearchQuery}
							storeRouteState={this.storeRouteState}
							reuseInput={this.createInput} />
					</div>
				);
			} else if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE && this.guidedInputs.indexOf(this.state.inputType) !== -1) {
				let inputPanel = null;

				if (this.state.inputType === constants.INPUT_TYPE_TWITTER) {
					inputPanel = (
						<TwitterInputConfigPanel
                            {...this.props}
                            input={this.state.editedInput}
                            changeHandler={FormUtilityMixin.requestChange.bind(this)}
                            statePath={"editedInput"}
							showBehavior={false} />
					);
				} else {
					inputPanel = (
						<CreateSubtypePanel
							{...this.props}
							input={this.state.editedInput}
							subtype={this.state.inputType}
							validateInput={this.validateInputConfiguration}
							changeHandler={FormUtilityMixin.requestChange.bind(this)}
							statePath="editedInput" />
					)
				}

				MainContent = (
					<div>
						<NewRouteProgress
							{...this.props}
							inputType={this.state.inputType}
							currentSection={1}
							goToStep={this.goToStep}
							newRoute={this.state.route} />
						{inputPanel}
						<EditorButtons
							{...this.props}
							showCancel={false}
							saveActive={true}
							saveLabel={"Post Settings >"}
							returnToTiles={this.returnToTiles}
							saveAction={this.validateInputConfiguration} />
					</div>
				);
			} else {
				// let's make sure COMPLEX gets the right icon in FeedEditorTabs
				let inputType = this.state.inputType;
				if (inputType === 0 && this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
					inputType = constants.INPUT_TYPE_FEED;
				} else if (inputType === 'feed_search_tile' || inputType === 'website_tile') {
					inputType = constants.INPUT_TYPE_FEED;
				}

				if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
					progressBlock = (
						<FeedEditorTabs
							{...this.props}
							inputType={inputType}
							currentSection="feed"
							showSocial={true}
							showOrientation={false}/>
					);
				} else {
					progressBlock = (
						<NewRouteProgress
							{...this.props}
							inputType={inputType}
							currentSection={1}
							goToStep={this.goToStep}
							newRoute={this.state.route}/>
					);
				}

				MainContent = (
					<div>
						{progressBlock}
						<CreateFeed
							{...this.props}
							onboarding={onboarding}
							onFeedSelect={this.createInput}
							onFeedRemoval={this.feedRemoval}
							initialFeeds={this.state.route.inputs}
							canAddFeeds={canAddFeeds}
							onAdvancedFeedConfigure={this.onAdvancedFeedConfigure}
							onSocialClick={this.storeRouteState}
							onSubtypeClick={this.onSubtypeClick}
							recordPath={this.props.recordPath}
							searchErrors={searchErrors}
							removeInvalidFeeds={this.removeInvalidFeeds}
							externalFeedUrl={this.state.externalFeedUrl}
							twitterInput={twitterInput}
							inputCount={inputCount}
							returnToTiles={this.returnToTiles}
							inputType={this.state.inputType}
							isValidating={this.state.validatingFeed}
							searchQuery={this.state.searchQuery} />
						{EditorButton}
					</div>
				);
			}


			if (currentPath.match('new/configure') && this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
				modal = (
					<InputModal
						{...this.props}
						input={this.state.editedInput}
						errors={this.state.validationErrors}
						onModalClose={this.onModalClose}
						onSave={this.modalSave}
						baseUrl={this.state.baseUrl} />
				);
			}
		} else if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_SIMPLE && currentPath.match("new/configure")) {
			tabClass = "editor-title-tab";

			if (currentPath.match("new/configure/input")) {
				tabClass = "editor-title-tab tab-active";
				feedLink = "new-route-configure";
			}

			if (onboarding === null) {
				Header = (
					<CreateFeedHeader
						{...this.props}
						sectionLink="/share/automate"
						section="Your Feeds"
						action="New Feed"
						tabs={HeaderTabs} />
				);
			}

			ConfigPanel = (
				<CreateFeedConfigure
					{...this.props}
					input={this.state.editedInput}
					errors={this.state.validationErrors}
					changeHandler={FormUtilityMixin.requestChange.bind(this)}
					textRuleHandler={this.requestTextRuleChange}
					scheduleHandler={this.requestScheduleChange}
					statePath="editedInput" />
			);

			feedType = (this.state.editedInput.subtype !== undefined) ? this.state.editedInput.subtype : this.state.editedInput.type;

			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
				progressBlock = (
					<FeedEditorTabs
						 {...this.props}
						 inputType={feedType}
						 feedLabel={this.state.editedInput.name}
						 showSocial={true}
						 showOrientation={showOrientation}
						 currentSection="config"/>
				);
			} else {
				progressBlock = (
					<NewRouteProgress
						 {...this.props}
						 inputType={feedType}
						 feedLabel={this.state.editedInput.name}
						 goToStep={this.goToStep}
						 currentSection={2}
						 newRoute={this.state.route}/>
				);
			}

			MainContent = (
				<div>
					{progressBlock}
					{errorNotice}
					{ConfigPanel}
					<EditorButtons
						{...this.props}
						showCancel={false}
						saveActive={true}
						stepLabel=''
						saveLabel={
							<span>Select outputs <i className="icon ion-ios-arrow-right"></i></span>
						}
						saveAction={this.validateInputConfiguration} />
				</div>
			);
		} else if (currentPath.match("new/outputs")) {

			feedType = (this.state.route.inputs[0].subtype) ? this.state.route.inputs[0].subtype : this.state.route.inputs[0].type;

			if(this.props.socials.list.length === 0) {
				this.storeRouteState();
			}

			let twitterCount = 0;
			for (let key in this.props.socials.list) {
				let test = _.find(this.props.socials.list, function(social) {
					return this.props.socials.list[key] == social.id;
				}.bind(this));
				if (test !== undefined) {
					if (test.psID == constants.POST_SVC_TWITTER) {
						++twitterCount;
					}
				}
			}

			if ((this.props.socials.list.length > 14 && (this.props.socials.filter === undefined || (this.props.socials.filter !== undefined && !this.props.socials.filter.value))) ||
				(this.props.socials.filter !== undefined && this.props.socials.filter.value && this.props.socials.filteredList.length > 14)) {
				let topButtonClass = (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) ? "social-list-top advanced" : "social-list-top";
				topEditorButton = <EditorButtons
									{...this.props}
									showCancel={false}
									saveActive={this.state.socialButtonActive}
									saveLabel={"Start posting"}
									saveAction={this.saveNewRoute}
									extraComponentClasses={topButtonClass} />;
			}

			let creatingSocial = this.state.creatingSocial || this.props.app.loading.SOCIAL_LIST;

			if (this.props.app.flags.routeViewType === constants.ROUTE_VIEW_ADVANCED) {
				progressBlock = (
					<FeedEditorTabs
						{...this.props}
						inputType={feedType}
						feedLabel={this.state.route.inputs[0].name}
						showSocial={true}
						showOrientation={showOrientation}
						currentSection="social" />
				);
			} else {
				progressBlock = (
					<NewRouteProgress
						{...this.props}
						inputType={feedType}
						feedLabel={this.state.route.inputs[0].name}
						goToStep={this.goToStep}
						currentSection={3}
						newRoute={this.state.route} />
				);
			}

			if (this.state.showPostGroupModal) {
				let cancelAction = () => {
					this.setState({
						showPostGroupModal: false
					});
				};

				modal = (
					<AccessoryModal
						content={
							<PostingGroups
								{...this.props}
								confirmAction={(socials) => {
									for (let i = 0; i < socials.length; ++i) {
										this.onSocialClick(null, parseInt(socials[i]));
									}
									this.setState({
										showPostGroupModal: false
									});
								}}
								cancelAction={cancelAction}/>
						}
						cancelAction={cancelAction}/>
				);
			}

			MainContent = (
				<div className="create-feed-social-wrapper">
					{progressBlock}
					<CreateFeedSocial
						{...this.props}
						route={this.state.route}
						displayHeader={false}
						onboarding={onboarding}
						outputs={[]}
						socialSearch={this.filterSocialsByName}
						socialFilter={this.filterSocialsByType}
						socialClickHandler={this.onSocialClick}
						selectedSocials={this.state.route.socials}
						connectHandler={this.onConnectSocial}
						creatingSocial={creatingSocial}
						mainTweeter={this.state.mainTweeter}
						setMainTweeter={this.setMainTweeter}
						resetTwitters={this.resetTwitters}
						topButton={topEditorButton}
						showPostGroupModal={this.showPostGroupModal}
						routeCreateError={this.state.routeCreateError}/>
					<EditorButtons
						{...this.props}
						showCancel={false}
						saveActive={this.state.socialButtonActive}
						saveLabel={"Start posting"}
						saveAction={this.saveNewRoute} />
				</div>
			);

		}

		return (
			<Content {...this.props} header={Header} main={MainContent} modal={modal}/>
		);
	}
};

RouteNew.reportedErrors = [];
RouteNew.displayName = "RouteNew";

const enhance = compose(
	ComponentWithContext,
	FeedProvider
);

export default enhance(RouteNew);
